import styled from 'styled-components';
import {dFlex, dFlexColumn} from '../../../../globalVariables/GlobalFlex';

export const info = styled.div`
    ${dFlexColumn};
    flex: none;
    margin: var(--space-md) var(--space-lg) 0;
    padding: 0 var(--space-md);
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--border-radius-border-radius-md);
`;

export const row = styled.div`
    ${dFlex};
    gap: var(--space-lg);
    min-width: 0;
    padding: var(--space-sm) 0;

    & + & {
        border-top: 1px dotted var(--color-border-subtle);
    }
`;

export const field = styled.div`
    ${dFlexColumn};
    flex: 1 1 0;
    gap: var(--space-2xs);
    min-width: 0;
`;

export const label = styled.span`
    font-size: var(--font-size-helper);
    font-weight: var(--font-weight-regular);
    color: var(--color-text-subtle);
`;

export const value = styled.span<{$numeric?: boolean}>`
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-regular);
    color: var(--color-text-default);
    overflow-wrap: anywhere;
    white-space: ${({$numeric}) => ($numeric ? 'nowrap' : 'normal')};
`;
